import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { usePagesPage } from "../../context";
import ActionButtons from "./components/ActionButtons";
import Tabs from "./components/Tabs";
import { useTabsContent } from "./components/Tabs/utils";
import { PageDetailsProvider, usePageDetails } from "./context";
import PageDetailsSkeleton from "./skeleton";

const PageDetailsContainer: FC = () => (
  <PageDetailsProvider>
    <PageDetails />
  </PageDetailsProvider>
);

const PageDetails: FC = () => {
  const { pageDrawer } = usePagesPage();
  const { onClosePageDetails, isLoading } = usePageDetails();
  const Component = useTabsContent();

  const title = pageDrawer.drawerDetails ? "Edit page" : "Add new page";

  return (
    <Drawer
      title={title}
      isOpen={pageDrawer.isOpen}
      onCloseDrawer={onClosePageDetails}
      headingRight={<ActionButtons />}
      headingBottom={<Tabs />}
    >
      {isLoading && <PageDetailsSkeleton />}
      {!isLoading && <Component />}
    </Drawer>
  );
};

export default PageDetailsContainer;
